module.exports = __webpack_public_path__ + "static/img/m249swa.6abc114.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/m249swa.png
// module id = qvkb
// module chunks = 0